import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLang } from "../lib/providers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterUnsubscribePage() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ loading: false, ok: false }); return; }
    axios.get(`${API}/newsletter/unsubscribe`, { params: { token } })
      .then((r) => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, ok: false }));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-black">
      <div className="max-w-md w-full text-center border border-white/10 p-8 bg-black/60" dir={lang === "ar" ? "rtl" : "ltr"}>
        {state.loading ? <Loader2 className="w-10 h-10 text-neon mx-auto animate-spin" />
          : state.ok ? (
            <>
              <CheckCircle2 className="w-14 h-14 text-neon mx-auto mb-4" />
              <h1 className="text-2xl font-black uppercase tracking-tight mb-2" data-testid="newsletter-unsub-success">
                {lang === "ar" ? "تم إلغاء الاشتراك" : "Désinscription effectuée"}
              </h1>
              <p className="text-sm text-white/70">
                {lang === "ar" ? "لن تتلقى المزيد من رسائلنا. نأسف لرؤيتك ترحل !" : "Vous ne recevrez plus nos emails. Désolé de vous voir partir !"}
              </p>
            </>
          ) : (
            <>
              <XCircle className="w-14 h-14 text-clay mx-auto mb-4" />
              <h1 className="text-2xl font-black uppercase tracking-tight mb-2" data-testid="newsletter-unsub-error">
                {lang === "ar" ? "رابط غير صالح" : "Lien invalide"}
              </h1>
            </>
          )}
        <Link to="/" className="inline-block mt-6 px-6 py-3 bg-neon text-black font-black uppercase tracking-widest text-sm hover:opacity-90">
          {lang === "ar" ? "العودة إلى المتجر" : "Retour à la boutique"}
        </Link>
      </div>
    </div>
  );
}
